import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  states: [],
  districts: [],
  areas: [],
  roles :[],
  categories :[]
};

const regionSlice = createSlice({
  name: "region",
  initialState,
  reducers: {
    setStates: (state, action) => {
      state.states = action.payload;
    },
    setDistricts: (state, action) => {
      state.districts = action.payload;
    },
    setAreas: (state, action) => {
      state.areas = action.payload;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    setCategories : (state, action) => {
        state.categories = action.payload;
    }
  },
});

export const { setStates, setDistricts, setAreas,setRoles,setCategories } = regionSlice.actions;
export default regionSlice.reducer;
